import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Justifications } from 'contracts/Justifications';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_JUSTIFICATIONS_',
  }
);

export interface ListJustificationsState {
  data: Justifications[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListJustificationsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Justifications[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListJustificationsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListJustificationsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListJustificationsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListJustificationsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListJustificationsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listJustifications = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListJustificationsTypes = Types;
export const ListJustificationsActions = Creators;
